export interface Tree {
  name: string;
  title?: string;
  friendlyName: string;
  version: string;
  type: TreeType;
  categories: TreeCategory[];
}

export interface TreeCategory {
  id: string;
  name: string;
  friendlyName: string;
  source: string;
  version: string;
  refNo: string;
  order: number;
  tree: string;
  excludeEmissions?: boolean;
  subCategories: TreeCategory[];
  accounting: TreeAccounting[];
  variables: string[];
}

export interface TreeAccounting {
  id: string;
  scope?: AccountingScope;
  ccc: string;
}

export enum AccountingScope {
  SCOPE_1 = 'SCOPE_1',
  SCOPE_2 = 'SCOPE_2',
  SCOPE_3 = 'SCOPE_3',
}

type TreeType = 'DISPLAY' | 'REPORTING';
